import { render } from "./DepositNew.vue?vue&type=template&id=183bb099&scoped=true&ts=true"
import script from "./DepositNew.vue?vue&type=script&lang=ts"
export * from "./DepositNew.vue?vue&type=script&lang=ts"

import "./DepositNew.vue?vue&type=style&index=0&id=183bb099&lang=css&scoped=true"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183bb099"]])

export default __exports__